// export enum ConnectionSizeCategory {
//     v_small = "v_small",
//     small = "small",
//     medium = "medium",
//     large = "large",
//     v_large = "v_large",
//     bulk = "bulk"
// }

// export enum ProviderType {
//     coastal,
//     indigenous_councils,
//     resource_councils,
//     rural_regional,
//     rural_remote,
//     south_east_queensland,
//     other
// }

// export enum ConnectionSizeCategory {
//     v_small = "v_small",
//     small = "small",
//     medium = "medium",
//     large = "large",
//     v_large = "v_large",
//     bulk = "bulk"
// }

export enum FilterOption {
    // provider_id = "provIds",
    // provider_type = "prov",
    connection_size = "conn",
    region = "regi"
}

export interface FieldSummaryMetadata {
    // url param key
    // connection size params defined by the front end
    // region params defined by the back end
    // id: ConnectionSizeCategory | string;
    id: string;

    //| Region | ProviderType;
    // access value if it's a facet query
    access: string | null | undefined;

    // label displayed on the UI
    label: string;

    // value used in the query
    value: string | number | null | undefined;

    // color to be displayed as a legend item if necessary
    color?: string;

    // param to make filter api call
    queryRange?: string;
    queryRangeStart?: number;
    queryRangeEnd?: number;
}

export interface FieldSummary extends FieldSummaryMetadata {
    amount: number;
    filteredAmount?: number;
    disabled?: boolean;
}

export interface FilterMetadata {
    label: string;
    options: FieldSummary[];
}

export interface FilterMetadataWithDefaultSelections extends FilterMetadata {
    defaults: string[];
}

export interface SelectDisplay extends FilterMetadata {
    category: string;
    checkValues?: string[];
    onChange?: (category: string, value: string, checked: boolean) => void;
    loading?: boolean;
}
